module.exports = __webpack_public_path__ + "static/media/navy.dec5cea4.jpg";